<template>
  <form
    autocomplete="off"
    class="category-edit__form"
    v-on:submit.prevent="onSubmit"
  >
    <input-text
      required="required"
      title="Название категории"
      v-bind:maxlength="255"
      v-bind:violations="nameErrors"
      v-model.trim="name"
      v-letter-capital
      show-counter />
    <div class="category-edit__form__buttons">
      <button
        class="category-edit__form__button-cancel"
        type="button"
        v-on:click.prevent="onCancel">
        Отмена
      </button>
      <button type="submit" class="category-edit__form__button-save">
        Сохранить
      </button>
    </div>
  </form>
</template>
<script>
import InputText from '@/components/InputText.vue';
import { TreatmentPlanTemplateCategoryEditRequest } from '@/storage/gateways/PlanGateway';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Наименование события отмены.
 * @type {string}
 */
const NAME_EVENT_ON_CANCEL = 'cancel';

/**
 * @description Наименование события отправки формы.
 * @type {string}
 */
const NAME_EVENT_ON_SUBMIT = 'on-submit';

export default {
  /**
   * @description Форма редактирования категории плана шаблона лечения.
   */
  name: 'FormTreatmentPlanTemplateCategoryEdit',
  components: { InputText },
  computed: {
    /**
     * @description Ошибки в наименовании категории.
     * @returns {Array}
     */
    nameErrors: resolveInputErrors('category-name-edit'),
  },
  data() {
    return {
      /**
       * @description Наименование категории.
       * @type {String}
       */
      name: this.initialName,
    };
  },
  props: {
    /**
     * @description Начальное значение имени.
     * @type {String}
     */
    initialName: {
      type: String,
      required: true,
    },
    /**
     * @description Начальное значение идентификатора.
     * @type {Number}
     */
    initialId: {
      type: Number,
      required: true,
    },
    /**
     * @description Нарушения ограничений.
     * @type {any}
     */
    inputErrors: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /**
     * @description Отправить форму.
     * @returns {void}
     */
    onSubmit() {
      const request = new TreatmentPlanTemplateCategoryEditRequest(this.initialId, this.name);
      this.$emit(NAME_EVENT_ON_SUBMIT, request);
    },
    /**
     * @description Отменить.
     * @returns {void}
     */
    onCancel() {
      this.$emit(NAME_EVENT_ON_CANCEL);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.category-edit {
  position: relative;
  &__caption {
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
  }
  &__exit {
    position: absolute;
    right: -15px;
    top: 0px;
    background-image: url("@/assets/img/exit-black.svg");
    background-position: center;
    background-size: auto;
    background-repeat: no-repeat;
    background-color: #eaeff3;
    padding: 9px;
    border-radius: 2px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    &:hover {
      background-color: transparent;
    }
  }
  &__form {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 49px 0 0 0;
    &__group {
      display: flex;
      flex-direction: column;
      gap: 10px;
      &.field_error {
        .category-edit__form__label {
          color: var(--warning-color);
        }
      }
    }
    &__label {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #90a0b7;
      margin: 0 0 2px 0;
    }
    &__input {
      background: #ffffff;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      width: 100%;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
      }
      &:disabled {
        background-color: #fff;
      }
    }
    &__select {
      background-color: #ffffff;
      background-image: url("@/assets/img/checked/checked-grey.svg");
      background-position: right 17px center;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
        background-image: url("@/assets/img/checked/checked-grey-top.svg");
      }
      &:disabled {
        background-color: #fff;
        background-image: url("@/assets/img/checked/checked-grey.svg");
      }
    }
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      max-width: 438px;
      width: 100%;
      margin: 30px 0 0 auto;
    }
    &__button {
      &-cancel {
        @include buttons.btn-transparent(100%, 56px, 20px);
      }
      &-save {
        @include buttons.btn-blue(100%, 56px, 20px);
      }
    }
    &__error-text {
      color: var(--warning-color);
      font-size: 12px;
      line-height: 12px;
      padding: 0;
      margin: 0;
    }
  }
}
</style>
